import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class BearHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = false;
    this.type = "bear";

    this.build();
  }

  build() {
    super.build();

    // NOTE: as we reuse the same texture, calling "play" animates ALL the bears
    // Important to know if we have more than one bear in the game
    this.testedTile = new PIXI.Sprite(app.game.assets["tile-ours"]);
    this.testedTile.texture.source.resource.pause();
    this.testedTile.texture.source.resource.currentTime = 0;
    this.testedTile.position.set(-24, -81);
    this.testedTile.scale.set(0.95);
    this.testedTile.alpha = 0;
    this.addChild(this.testedTile);
  }

  test() {
    // Bear acts differently
    // If you test it with the harpon, you automatically lose a life
    app.game.lockPlayerActions();
    app.game.player.error();
    app.audio.play(app.data.global.sounds.bear_attack, 1.0, true);
  }

  hit() {
    this.maskTile.hide();

    // Add a little delay because we trigger the hit as soon as we move
    setTimeout(() => {
      app.audio.play(app.data.global.sounds.obstacle, 1.0, true);
      app.audio.play(app.data.global.sounds.bear_attack, 1.0, true);
    }, app.game.player.playerMovementDuration);
  }

  show() {

    gsap.to(this.testedTile, {
      pixi: {
        alpha: 1
      },
      duration: 0.5,
      ease: "power1.inOut",
      onComplete: () => {

        setTimeout(() => {
          // Show mask when anim ends
          this.maskTile.show();
        }, 1500)

        this.shown = true;

        this.testedTile.texture.source.resource.play();
      }
    })
  }

  endOfTurnAction() {
    // To be overwritten in child if needed
    if (!this.shown && this.isLessThanOneCellsFromPlayer()) {
      this.show();
    }

    if (this.shown) {
      this.maskTile.show();
    }
  }

  endGame() {
    app.game.endGame();
    app.animateOutGame(7);
  }

  // Reset the states so we can animate in again and start over
  reset() {
    // this.testedTile.alpha = 0;
    // this.testedTile.texture.source.resource.pause();
    // this.testedTile.texture.source.resource.currentTime = 0;
  }


}
